import SpinningIcon, { SpinningIconProps } from './SpinningIcon';

export type { SpinningIconProps };
export default SpinningIcon;
